import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: linear-gradient(
    ${(props) => props.theme.colors.loginBackgroundDegradado.angle},
    ${(props) => props.theme.colors.loginBackgroundDegradado.start} 4.71%,
    ${(props) => props.theme.colors.loginBackgroundDegradado.middle} 39.15%,
    ${(props) => props.theme.colors.loginBackgroundDegradado.end} 86.18%
  );
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

const Spinner = styled.div`
  width: 48px;
  height: 48px;
  border: 4px solid ${(props) => props.theme.colors.text.disabled};
  border-top-color: ${(props) => props.theme.colors.primary[1000]};
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;

export const LoadingScreen = () => {
  return (
    <Container>
      <Spinner />
    </Container>
  );
};

